export default __webpack_public_path__ + "c66317fa03766935a5e79b3e82a89200.svg";